<template>
  <div class="footer-btn">
    <div class="defaults-btn" v-if="title" @click="submit">
      <p>{{title}}</p>
      <slot name="icon"></slot>
    </div>
    <slot v-else name="btn"></slot>
  </div>
</template>

<script>
export default {
  name: "FooterBtn",
  props: {
    title: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    submit() {
      this.$emit("submit");
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  background: #fff;
  box-shadow: 0px -10px 16px 0px rgba(0, 0, 0, 0.02);
  .defaults-btn {
    width: 688px;
    height: 74px;
    margin: 13px auto;
    border-radius: 37px;
    background: $theme_color;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 74px;
    position: relative;
  }
}
</style>
